/**
 * Session values are plain text (company id, timezone, session ids) — never HTML.
 * Neutralize characters that could be interpreted as markup if they reach the DOM.
 */
export function sanitizeHtmlFromStoredText(value) {
	if (value === null || value === undefined) {
		return null;
	}
	return String(value)
		.replace(/[\0-\x08\x0b\x0c\x0e-\x1f\x7f]/g, '')
		.replace(/[<>"']/g, '');
}

export var SessionStorageUtil = {

	getItem: function(key) {
		var raw = sessionStorage.getItem(key);
		if (raw === null) {
			return null;
		}
		return sanitizeHtmlFromStoredText(raw);
	},

	setItem: function(key, value) {
		if (value === null || value === undefined) {
			sessionStorage.removeItem(key);
			return;
		}
		sessionStorage.setItem(key, sanitizeHtmlFromStoredText(value));
	},

	removeItem: function(key) {
		sessionStorage.removeItem(key);
	}
};

/**
 * Ensures any direct sessionStorage.getItem / setItem use text sanitization (defense in depth).
 */
export function installSessionStorageTextSanitizer() {
	if (typeof sessionStorage === 'undefined' || sessionStorage.__dlTextSanitizerInstalled) {
		return;
	}
	var originalGetItem = Storage.prototype.getItem;
	var originalSetItem = Storage.prototype.setItem;

	Storage.prototype.getItem = function(key) {
		var value = originalGetItem.call(this, key);
		if (value === null) {
			return null;
		}
		if (this === sessionStorage) {
			return sanitizeHtmlFromStoredText(value);
		}
		return value;
	};

	Storage.prototype.setItem = function(key, value) {
		if (this === sessionStorage && value !== null && value !== undefined) {
			originalSetItem.call(this, key, sanitizeHtmlFromStoredText(value));
			return;
		}
		originalSetItem.call(this, key, value);
	};

	sessionStorage.__dlTextSanitizerInstalled = true;
}
